import { render } from "./VFooter.vue?vue&type=template&id=563412fa"
import script from "./VFooter.vue?vue&type=script&lang=js"
export * from "./VFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__